import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { reduxForm, Field, submit, Form } from 'redux-form/immutable';
import FlatButton from 'material-ui/FlatButton';

import {
  TextField,
} from 'redux-form-material-ui';

import ReduxDialog from '../Common/ReduxDialog';

import commonStyles from '../styles';
import styles from './styles';

import { fetchTaskProfile } from '../../actions/taskprofiles';
import { showDialog, hideDialog } from '../../actions/dialogs';
import { saveTaskProfileFormHandler } from '../../routines';
import { renderTaskProfileItemTypes } from '../../utils/reduxforms';

class TaskProfile extends Component {
  static propTypes = {
    itemTypes: PropTypes.object.isRequired,

    initialValues: PropTypes.object.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    submit: PropTypes.func.isRequired,

    showDialog: PropTypes.func.isRequired,
    hideDialog: PropTypes.func.isRequired,
  };

  state = {};

  componentWillMount() {
  }

  handleDiscard = () => {
    this.props.hideDialog('taskprofile');
  };

  handleSave = () => {
    console.log('handleSave');
  };

  handleRemoveItemType = (itemType) => {
    const context = {
      type: 'warning',
      title: 'Remove Item?',
      message: 'Are you sure you wish to remove this item?',
      buttons: [
        <FlatButton
          label="Cancel"
          onClick={() => this.props.hideDialog('confirm')}
        />,
        <FlatButton
          label="Remove"
          onClick={() => {
            this.props.hideDialog('confirm');
          }}
        />,
      ],
    };

    this.props.showDialog('confirm', context);
  };

  render() {
    const { handleSubmit, initialValues } = this.props;

    const actions = [
      <FlatButton
        label="Cancel"
        primary
        onClick={this.handleDiscard}
      />,
      <FlatButton
        label="Save"
        primary
        onClick={() => this.props.submit('TaskProfile')}
      />,
    ];

    return (
      <ReduxDialog
        title={initialValues.get('name') || 'Create Task Profile...'}
        subTitle={'Task profiles allow you to define a common configuration of items for a task'}
        actions={actions}
        name="taskprofile"
        onRequestClose={this.handleDiscard}
        bodyStyle={styles.body}
      >
        <Form name="TaskProfile" onSubmit={handleSubmit(saveTaskProfileFormHandler)}>
          <div style={commonStyles.row}>
            <Field
              name="name"
              style={commonStyles.input}
              component={TextField}
              floatingLabelText="Name"
              floatingLabelFixed
              fullWidth/>
          </div>
          <div style={commonStyles.row}>
            <Field
              name="description"
              style={commonStyles.input}
              component={TextField}
              floatingLabelText="Description"
              floatingLabelFixed
              fullWidth
              multiLine
              rows={2}/>
          </div>

          <Field
            name="itemTypes"
            style={commonStyles.input}
            component={renderTaskProfileItemTypes}
            floatingLabelText="Name"
            floatingLabelFixed
            fullWidth/>

        </Form>

      </ReduxDialog>
    );
  }
}

const form = reduxForm({
  form: 'TaskProfile',  // a unique identifier for this form
  onSubmitSuccess: (result, dispatch, props) => {
    console.log('onSubmitSuccess');
    props.hideDialog('taskprofile');
  },
  onSubmitFail: (err) => {
    console.log('onSubmitFail', err);
  },
})(TaskProfile);

function mapDispatchToProps(dispatch) {
  return bindActionCreators({
    fetchTaskProfile,

    submit,
    showDialog,
    hideDialog,
  }, dispatch);
}

function mapStateToProps(state) {
  return {
    initialValues: state.getIn(['dialogs', 'dialogs', 'taskprofile', 'context', 'taskProfile']).toJS(),
    itemTypes: state.get('itemtypes').get('itemTypes').toJS(),
    dialogs: state.get('dialogs').get('dialogs').toJS(),
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(form);



// WEBPACK FOOTER //
// ./src/components/TaskProfile/index.js